/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayBrightnessSlider_ConfigFragment = { __typename: 'ConfigurationModel', id: string, brightness?: { __typename: 'ConfigBrightnessState', reported: number } | null };

export type ConfigUpdateBrightnessMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateBrightnessInput;
}>;


export type ConfigUpdateBrightnessMutation = { __typename: 'Mutation', configurationUpdateBrightness: { __typename: 'ConfigurationModel', id: string, brightness?: { __typename: 'ConfigBrightnessState', reported: number } | null } };

export const ConfigDisplayBrightnessSlider_ConfigFragmentDoc = gql`
    fragment ConfigDisplayBrightnessSlider_config on ConfigurationModel {
  id
  brightness {
    reported
  }
}
    `;
export const ConfigUpdateBrightnessDocument = gql`
    mutation ConfigUpdateBrightness($input: ConfigurationUpdateBrightnessInput!) {
  configurationUpdateBrightness(input: $input) {
    ...ConfigDisplayBrightnessSlider_config
  }
}
    ${ConfigDisplayBrightnessSlider_ConfigFragmentDoc}`;
export type ConfigUpdateBrightnessMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateBrightnessMutation, ConfigUpdateBrightnessMutationVariables>;

/**
 * __useConfigUpdateBrightnessMutation__
 *
 * To run a mutation, you first call `useConfigUpdateBrightnessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateBrightnessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateBrightnessMutation, { data, loading, error }] = useConfigUpdateBrightnessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateBrightnessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateBrightnessMutation, ConfigUpdateBrightnessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateBrightnessMutation, ConfigUpdateBrightnessMutationVariables>(ConfigUpdateBrightnessDocument, options);
      }
export type ConfigUpdateBrightnessMutationHookResult = ReturnType<typeof useConfigUpdateBrightnessMutation>;
export type ConfigUpdateBrightnessMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateBrightnessMutation>;
export type ConfigUpdateBrightnessMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateBrightnessMutation, ConfigUpdateBrightnessMutationVariables>;